
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.12 14.033l-2.289-.906-.095.43c0 .047-.048.047-.048.047h-.476c-.048 0-.048 0-.048-.048l-.095-.429-2.29.906h-.047l-.047-.048v-.524s-.048-.286.333-.525l1.812-1.144-.334-.238-.047-.048h-.334c-.048 0-.048 0-.048-.048s-.286-.715-.286-1.287.096-.763.096-.81l.476-.287-1.573.096-4.148 1.049-.382.286H.203l-.048-.048c0-.048-.095-.715.334-1.001.429-.286 4.243-2.05 4.386-2.146l1.67-1.096V4.116c0-.096.047-2.432.905-3.147h.095c.859.667.906 3.004.906 3.147v2.098l1.67 1.096c.142.096 4.004 1.86 4.386 2.146.429.286.333.953.333 1.001 0 0 0 .048-.047.048h-.048l-.43-.334-4.147-1.049-1.574-.095.477.238c.048.048.095.286.095.81 0 .525-.286 1.24-.286 1.288l-.047.048h-.334v.047l-.381.239 1.811 1.144c.382.238.334.524.334.524v.525s0 .048-.048.048c-.047.095-.095.095-.095.095z"}})])
          )
        }
      }
    